import { createStructuredSelector } from 'reselect';

import { selectAccountData } from './AgreementFlowSelectors';

export const agreementSummaryDerivedStates = createStructuredSelector({
  accountData: selectAccountData,
});
